import ConditionReport from "./ConditionReport";
import EntityStats from "./EntityStats";
import UnitScale from "./enums/UnitScale";
import PathInfo from "./PathInfo";

class e3dModel {
  constructor(
    public id_user: number,
    public name: string,
    public description: string,
    public id_chelement: number,
    public icon: number | undefined,
    public width: number,
    public length: number,
    public height: number,
    public scale: UnitScale,
    public reference_date: string,
    public id?: number | undefined,
    public GUID?: string | undefined,
    public created_on?: Date | undefined,
    public icon_path?: string | undefined,
    public parent?: PathInfo,
    public counts?: EntityStats[] | undefined,
    public username?: string | undefined,
    public condition_report?: ConditionReport
  ) {}

  public static EmptyInstance(): e3dModel {
    return new e3dModel(-1, "", "", -1, -1, 0, 0, 0, UnitScale.Centimeter, "");
  }
}

export default e3dModel;
